/****************************************************************
 * Responsibility - Displays the general notes for the order 🐺
 * *************************************************************
 * @format
 * */
import OrderDesignAlerts from 'frontier/account/components/proofing/order_meta/order_design_alerts';
import {PROOF_STATUS_DISAPPROVED} from 'frontier-constants';
import React, {useState, useEffect} from 'react';
import {If, IfElse} from 'frontier-utilities';

// styles
import './order_info_cards.scss';

export const OrderComments = props => {
    const {
        reviewNotesVerification,
        specsVerification,
        handleApproveNotes,
        currentProof,
        className,
        user
    } = props;
    const [shouldShowDisplayMore, setShouldShowDisplayMore] = useState(false);
    const [isViewingAllNotes, setIsViewingAllNotes] = useState(true);
    const [comments, setComments] = useState(currentProof.comment);

    const reasonsForDisapproval = currentProof.disapprove_reason?.split('\n') || [''];

    useEffect(() => {
        if (!isViewingAllNotes) {
            if (
                typeof currentProof.comment === 'string' &&
                currentProof.comment.split(' ').length > 30
            ) {
                // cut the comment to 30 words
                setComments(currentProof.comment.split(' ').slice(0, 30).join(' '));
                setShouldShowDisplayMore(true);
                return;
            }
        }

        setComments(currentProof.comment);
    }, [isViewingAllNotes]);

    return (
        <div className={`oder-notes-44oo bg-structure-lightest ${className}`}>
            <div className="order-notes-44oo__title d-flex align-items-start justify-content-start gap-3">
                <If condition={reviewNotesVerification.isVerified}>
                    <i className="fa fa-check color-accent-primary" style={{fontSize: 24}} />
                </If>
                <h3 className="color-structure-black m-0">Step 2: Review Proof Notes</h3>
            </div>

            <IfElse condition={comments.length === 0 && currentProof.designs_alerts.length === 0}>
                <p className="oder-notes-44oo__notes mb-3 ms-0 mt-0">
                    This proof has no notes attached. There may, however, still be artwork specific
                    notes included in the Review Artwork section.
                </p>

                <div className="oder-notes-44oo__notes mb-3 ms-0 mt-0">
                    <OrderDesignAlerts proofId={currentProof.id} />
                    <p>
                        {/* While we transition away, we want to show the old comments */}
                        {comments ?? ''}
                    </p>
                </div>
            </IfElse>

            <If condition={shouldShowDisplayMore}>
                <IfElse condition={!isViewingAllNotes}>
                    <button
                        className="mt-0 mx-0 mb-4 p-0 bg-transparent d-flex align-items-center justify-content-start gap-2 color-accent-primary"
                        onClick={() => setIsViewingAllNotes(!isViewingAllNotes)}>
                        <i className="fa fa-plus" />
                        <u>Show all specs</u>
                    </button>
                    <button
                        className="mt-0 mx-0 mb-4 p-0 bg-transparent d-flex align-items-center justify-content-start gap-2 color-accent-primary"
                        onClick={() => setIsViewingAllNotes(!isViewingAllNotes)}>
                        <i className="fa fa-minus" />
                        <u>Show less</u>
                    </button>
                </IfElse>
            </If>
            <If condition={currentProof.status === PROOF_STATUS_DISAPPROVED}>
                <div className="oder-notes-44oo__reasons-for-disapproval mt-4">
                    <h4 className="mt-0 mb-2 color-alert-negative">Reasons for disapproval</h4>
                    <If condition={reasonsForDisapproval.length > 0}>
                        <p className={'mt-0 mx-0 mb-2'}>
                            {reasonsForDisapproval.map((reason, i) => `• ${reason}, `)}
                        </p>
                    </If>
                </div>
            </If>
            {/* verification button and labels */}
            <IfElse condition={!reviewNotesVerification.isVerified}>
                {/* account for comments while we transition too*/}
                <If condition={currentProof.designs_alerts.length > 0 || comments.length > 0}>
                    <button
                        onClick={() => handleApproveNotes(user.email)}
                        className="btn btn--secondary btn-sm d-flex color-accent-primary gap-2 button--success  btn-outline-success mt-4">
                        <b>Approve proof notes</b>
                    </button>
                </If>
                <If
                    condition={
                        !!reviewNotesVerification.verifiedBy && !!reviewNotesVerification.verifiedOn
                    }>
                    <div className="oder-specs-98pw__specs-verified d-flex align-items-start justify-content-start gap-3 bg-structure-white mt-3">
                        <div>
                            <h4>Approved By</h4>
                            <p>{reviewNotesVerification.verifiedBy}</p>
                        </div>
                        <div>
                            <h4>Approved On</h4>
                            <p>{reviewNotesVerification.verifiedOn}</p>
                        </div>
                    </div>
                </If>
            </IfElse>
        </div>
    );
};
